import { styled } from "@mui/material/styles";

export const HoverTooltip = styled("div")(({ theme }) => ({
  backgroundColor: theme.vars.palette.background.default,
  border: "1px solid",
  borderColor: theme.palette.divider,
  position: "absolute",
  pointerEvents: "none",
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  fontSize: theme.typography.fontSize,
}));
